// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QrHV","importantInfo":"styles_importantInfo__3pJ_H"};